import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<path fill=\"#FFDA44\" d=\"M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12\"></path><path fill=\"#000\" d=\"M3.515 20.485q.757.754 1.604 1.348L21.834 5.118a12.1 12.1 0 0 0-2.952-2.951L2.168 18.881q.593.847 1.347 1.604\"></path><path fill=\"#6DA544\" d=\"M3.514 3.515C-.272 7.3-.998 12.986 1.333 17.502L17.502 1.333C12.986-.997 7.3-.271 3.514 3.515\"></path><path fill=\"#D80027\" d=\"M20.484 20.485c3.785-3.786 4.512-9.471 2.181-13.987L6.496 22.667c4.516 2.33 10.202 1.604 13.987-2.182\"></path><path fill=\"#F0F0F0\" d=\"m7.63 14.158 1.12.57.89-.888-.197 1.242 1.12.57-1.241.197-.197 1.242-.57-1.12-1.242.196.888-.889zM14.158 7.63l1.12.571.89-.889-.197 1.242 1.12.571-1.242.197-.197 1.241-.57-1.12-1.242.197.889-.89z\"></path>", 5)
const _hoisted_7 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_7]))
}
export default { render: render }